import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Note informative expliquant le périmètre de la franchise.
 * Affichée sous la sélection abonnement/franchise et sur les pages récap.
 *
 * @param {{ abonnement: 'S'|'M'|'L' }} props
 */
const FranchiseInfoNote = ({ abonnement }) => {
  const includesWearParts = abonnement === 'L';
  return (
    <div
      className="flex items-start gap-2 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-900"
      data-testid="franchise-info-note"
    >
      <AlertCircle className="h-4 w-4 mt-0.5 shrink-0 text-blue-600" />
      <p className="leading-relaxed">
        La franchise s'applique à chaque <strong>panne</strong> et à chaque <strong>réparation</strong>.
        Elle ne s'applique pas aux <strong>services d'entretien</strong>
        {includesWearParts && <> ni aux <strong>pièces d'usure</strong></>}
        , qui restent {includesWearParts ? 'tous deux ' : ''}inclus dans votre abonnement.
      </p>
    </div>
  );
};

export default FranchiseInfoNote;
